import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'
import { TouchEventInput } from '@/utils/touchEvent'

interface RecordTouchEventResult {
  success: boolean
  accepted: number
}

interface RecordTouchEventMutation {
  recordTouchEvent: RecordTouchEventResult
}

const RECORD_TOUCH_EVENT_MUTATION = gql`
  mutation recordTouchEvent($input: MarketingTouchEventInput!) {
    recordTouchEvent(input: $input) {
      success
      accepted
    }
  }
`

export const useRecordTouchEventApi = (): UseMutationResult<
  RecordTouchEventResult,
  Error,
  TouchEventInput
> => {
  const client = useGraphQLClient()

  const recordTouchEvent = async (input: TouchEventInput): Promise<RecordTouchEventResult> => {
    const result = await client.request<RecordTouchEventMutation>(RECORD_TOUCH_EVENT_MUTATION, {
      input,
    })

    return result.recordTouchEvent
  }

  return useMutation<RecordTouchEventResult, Error, TouchEventInput>({
    mutationFn: recordTouchEvent,
  })
}

export default useRecordTouchEventApi
